module.exports = __webpack_public_path__ + "img/moon.5947fcb1.svg";